import React from 'react'
import { AgGridReact } from "ag-grid-react";
import { AllEnterpriseModule } from "ag-grid-enterprise";
import { ModuleRegistry, AllCommunityModule, themeBalham } from 'ag-grid-community';
import { useEffect, useState, useRef } from 'react';
import { isEmpty, GetExtension, getWindowDimensions, isEnabled } from '../../modules/appLibrary';
import { useDispatch, useSelector } from "react-redux";
import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import Iframe from "react-iframe";
import Container from '@mui/material/Container';
import IconButton from '@mui/material/IconButton';
import CloseIcon from '@mui/icons-material/Close';
import Button from '@mui/material/Button';
import HinbanRenderFile from "./HinbanRenderFile";
import AGFunction from "../../components/AGFunction";

// 必要なモジュールを登録
ModuleRegistry.registerModules([
    AllEnterpriseModule,
    AllCommunityModule
]);

//--------------------------------------------------------
//  関連ファイルGrid
//
//  dataRef:入力データ
//  spec:true=仕様書チェック追加
//  fnc
//  onGridReady
//  onFirstDataRendered
//  deleteFile:削除コールバック
//  ValueChanged:値変更イベント
//  DataRowChanged:行変更イベント
//--------------------------------------------------------
export default function HinbanEntryFiles(props) {

    const formstatus = useSelector(state => state.form.status);
    const [rowData, setRowData] = useState([]);
    const [open, setOpen] = useState(false);
    const [title, setTitle] = useState();
    const [url, setUrl] = useState();
    const [windowDimensions, setWindowDimensions] = useState(getWindowDimensions());
    const fullname = useRef();
    const menuinfo = useSelector(state => state.form.menuinfo);
    const [spec, setspec] = useState(false);
    const AGRef = useRef();
    const AGFunc = React.forwardRef(AGFunction);
    const sectionLock = !!props.sectionLock;
    const columnDefs = [
        {
            headerName: "ファイル名",
            field: "filename",
            width: 350,
            rowDrag: true,
            cellRenderer: HinbanRenderFile,
            cellRendererParams: {
                type: 0,
                sectionLock: sectionLock,
                click: function (e) {
                    let params = {
                        "filename": e.data.fullname,
                        "dnfile": e.data.filename
                    }
                    props.fnc.current.filedownload("common/FileDownload", params);
                }
            }
        },
        {
            headerName: "種別",
            field: "filetype",
            width: 80
        },
        {
            headerName: "サイズ(K)",
            field: "filesize",
            width: 100,
            type: "rightAligned"
        },
        {
            headerName: "タイムスタンプ",
            field: "filedate",
            width: 150
        },
        ...(isEnabled(spec)
            ? [
                {
                    headerName: "仕様書",
                    field: "spec",
                    width: 50,
                    cellRenderer: HinbanRenderFile,
                    cellRendererParams: {
                        type: 2,
                        sectionLock: sectionLock,
                        checkchanged: (p, newvalue) => {
                            const row = props.dataRef.current.find(
                                (e) => e.filename === p.data.filename
                            );
                            row.kind = newvalue;
                        }
                    }
                }
            ]
            : []),

        {
            headerName: "備考",
            field: "note",
            editable: !sectionLock,
            width: 400
        },

        {
            headerName: "削除",
            field: "delete",
            width: 50,
            filter: false,
            sortable: false
        }
    ]

    useEffect(() => {
        let g_row = props.dataRef.current;
        if (!isEmpty(g_row)) {
            setRowData(g_row);
        } else {
            setRowData([]);
        }
    }, []);

    useEffect(() => {
        function handleResize() {
            setWindowDimensions(getWindowDimensions());
        }
        window.addEventListener('resize', handleResize);
        return () => window.removeEventListener('resize', handleResize);

    }, []);

    useEffect(() => {
        if (isEmpty(menuinfo.ctrls)) return;
        setspec(menuinfo.ctrls.indexOf("FILESPEC") !== -1);
    }, [menuinfo]);


    function handleClose() {
        setOpen(false);
    }


    function onGridReady(params) {
        if (isEmpty(props.onGridReady)) return;
        props.onGridReady(params);
    }
    function onCellDoubleClicked(params) {
        if (sectionLock) return;
        if (params.column.colId !== "filename") return;
        var filename = params.data["imageurl"];
        if (isEmpty(filename)) return;
        let ex = GetExtension(filename).toLowerCase();
        if (ex === "xlsx" || ex === "xls") {
            props.fnc.current.postaxios('common/ExceltoPDF',
                {
                    fullname: params.data["fullname"],
                    imageurl:filename
                },
                {
                    onSuccess: function (data) {
                        setUrl(data.request);
                        setTitle(params.data["filename"]);
                        fullname.current = params.data["fullname"]
                        props.fnc.current.wait(false);
                        setOpen(true);
                    },
                    onError: function (data) {
                        props.fnc.current.wait(false);
                        window.open(filename);      //file download
                    }
                }
            )
        } else {
            setUrl(filename);
            setTitle(params.data["filename"]);
            fullname.current = params.data["fullname"]
            setOpen(true);
        }
    }
    //ファイルダウンロード
    function Download() {
        let params = {
            "filename": fullname.current,
            "dnfile": title
        }
        props.fnc.current.filedownload("common/FileDownload", params);
    }

    function getMainMenuItems(params) {
        const athleteMenuItems = params.defaultItems.slice(0);
        //pin以外のメニュクリア
        athleteMenuItems.pop();
        athleteMenuItems.pop();
        athleteMenuItems.pop();
        athleteMenuItems.pop();
        athleteMenuItems.pop();
        athleteMenuItems.push({
            name: '列幅最適化-すべての列',
            action: () => {
                var allColumnIds = [];
                params.api.getAllGridColumns().forEach(function (column) {
                    if (column.colId !== 'grip')
                        allColumnIds.push(column.colId);
                });
                params.api.autoSizeColumns(allColumnIds, false);
            },
        });
        athleteMenuItems.push({
            name: '列幅最適化-指定列',
            action: () => {
                params.api.autoSizeColumns(params.column.colId, false);
            },
        });
        return athleteMenuItems;
    };

    //行入れ替え
    function RowDragEnd(param) {
        if (sectionLock) return;
        props.dataRef.current = AGRef.current.GetDatasource(param.api);
    }

    //ファイル削除 v1.4
    function removefile(e) {
        let filename = e.data.filename;
        if (formstatus === 'ENTRY FORM') {
            let msg = "「" + filename + "」をクラウド上から削除します。よろしいですか？";
            if (isEmpty(props.deleteFile))
                props.fnc.current.confmsg(msg, () => deleteFile(filename));
            else
                props.fnc.current.confmsg(msg, () => props.deleteFile(1,filename));
        } else {
            let msg = "「" + filename + "」を削除します。よろしいですか？";
            props.fnc.current.confmsg(msg, execute);
        }
        function execute() {
            props.dataRef.current = props.dataRef.current.filter(e => e.filename !== filename);
            if (props.dataRef.current.length === 0) {
                if (!isEmpty(props.rerender)) props.rerender();
            } else {
                setRowData(props.dataRef.current);
            }
        }
    }
    //File Delete v1.4
    function deleteFile(filename) {
        let urlctrl = props.controller;
        if (urlctrl.indexOf(":") !== -1) urlctrl = props.controller.split(":")[0];
        let url = urlctrl + "/FileDelete";
        if (!isEmpty(props.deleteurl)) {
            url = props.deleteurl;
        }
        props.fnc.current.postaxios(url, { "code": props.code, "subkey": filename, "controller": props.controller },
            {
                onSuccess: function (data) {
                    props.dataRef.current = props.dataRef.current.filter(e => e.filename !== filename);
                    if (props.dataRef.current.length === 0) {
                        if (!isEmpty(props.rerender)) props.rerender();
                    } else {
                        setRowData(props.dataRef.current);
                    }
                    props.fnc.current.wait(false);
                },
                errmsg: "ファイル削除に失敗しました"
            }
        )
    }

    return (
        <React.Fragment>
            <AGFunc ref={AGRef} />
        <div id="fileGrid" className="ag-theme-balham" style={{ width: '100%' }}>
            <AgGridReact
                theme={themeBalham}
                columnMenu="legacy"
                getRowId={params => params.data.rowid}
                modules={[AllCommunityModule, AllEnterpriseModule]}
                getRowNodeId={(data) => data.filename}
                headerHeight={30}
                defaultColDef={{
                    filter: true,
                    sortable: true,
                    resizable: true,
                }}
                popupParent={document.querySelector('body')}
                enableRangeSelection={true}
                suppressMultiRangeSelection={true}
                getMainMenuItems={getMainMenuItems}
                suppressContextMenu={true}
                rowDragManaged={!sectionLock}
                domLayout={'autoHeight'}
                onGridReady={onGridReady}
                onCellDoubleClicked={onCellDoubleClicked}
                onRowDragEnd={RowDragEnd}
                rowData={rowData}
                columnDefs={columnDefs}>
            </AgGridReact>
            </div>
            <Dialog onClose={handleClose} open={open} fullWidth={true} maxWidth={false}>
                <DialogTitle>{title}</DialogTitle>
                <Button
                    variant="outlined"
                    size="small"
                    onClick={Download}
                    sx={{
                        position: 'absolute',
                        right: 80,
                        top: 15
                    }}
                >
                    DOWNLOAD
                </Button>
                <IconButton
                    aria-label="close"
                    onClick={handleClose}
                    sx={{
                        position: 'absolute',
                        right: 8,
                        top: 8,
                        color: (theme) => theme.palette.grey[500],
                    }}
                >
                    <CloseIcon />
                </IconButton>
                <Container sx={{ height: windowDimensions.height - 100, width: '100%', pb: 5 }}>
                    <Iframe
                        url={url}
                        width="100%"
                        height="100%"
                    />
                </Container>
            </Dialog>

        </React.Fragment>
    );

}
